import React from 'react';

import { CheckCircle, ContentCopy, Download } from '@mui/icons-material';
import { Button, Card, Grid, Stack, Typography } from '@mui/material';

import { BackSubmitButton } from '@components/forms/currentUser/styles';
import SubmitButton from '@components/submitButton';

import copyToClipboard from '@utils/copyToClipboard';
import formatDate, { DATE_FORMATS } from '@utils/formatDate';

function SuccessStep({
	handleDownloadFile,
	handleEnableMfa,
	backupCodes,
	onDecline,
}: {
	handleDownloadFile: () => void;
	handleEnableMfa?: () => void;
	backupCodes: string[];
	onDecline: () => void;
}) {
	return (
		<Stack spacing={1} alignItems={'center'}>
			<CheckCircle sx={{ fontSize: 64, color: 'success.main' }} />
			<Typography variant={'subtitle1'} fontWeight={700} fontSize={18} textAlign={'center'}>
				TOTP verification is successfully done
			</Typography>
			<Typography variant={'subtitle1'} fontWeight={700} fontSize={18} textAlign={'center'}>
				Backup Verification Codes
			</Typography>
			<Typography variant={'body1'} fontWeight={400} textAlign={'center'}>
				We recommend you save them to keep in a safe place
			</Typography>

			<Grid container spacing={1}>
				{backupCodes.map(backupCode => (
					<Grid item sm={6} key={`backup-code-${backupCode}`}>
						<Card variant="outlined" sx={{ p: 1 }}>
							<Typography textAlign={'center'}>{backupCode}</Typography>
						</Card>
					</Grid>
				))}
			</Grid>

			<Typography textAlign={'center'} variant="body1">
				These codes were generated on {formatDate(new Date(), DATE_FORMATS.SHORT_DATE)}
			</Typography>

			<Stack alignItems={'center'}>
				<Button onClick={() => copyToClipboard(backupCodes.join('\n'))} startIcon={<ContentCopy />} variant="outlined">
					Copy All Codes
				</Button>
				<Typography variant="body1">or</Typography>
				<Button variant="outlined" startIcon={<Download />} onClick={handleDownloadFile}>
					Download File
				</Button>
			</Stack>

			<Stack direction="row" spacing={2} sx={{ width: '100%', pt: 1 }}>
				<BackSubmitButton fullWidth type="button" variant="contained" color="secondary" onClick={onDecline}>
					Back
				</BackSubmitButton>
				<SubmitButton fullWidth type="button" label={'Enable 2FA'} onClick={handleEnableMfa} />
			</Stack>
		</Stack>
	);
}

export default SuccessStep;
